import React from 'react';

/**
 * Modal para visualizar e copiar o JSON de um layout/template.
 */
export default function TemplateJsonExportModal({ open, onClose, fileName, jsonText, labels }) {
    if (!open) return null;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(jsonText);
            if (labels?.copied) alert(labels.copied);
        } catch {
            if (labels?.copyFailed) alert(labels.copyFailed);
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black/60 z-[10000] flex items-center justify-center p-4"
            role="dialog"
            aria-modal="true"
            aria-labelledby="template-json-export-title"
            onClick={onClose}
        >
            <div
                className="bg-white dark:bg-slate-800 rounded-2xl p-6 max-w-3xl w-full max-h-[90vh] flex flex-col shadow-xl border border-slate-200 dark:border-slate-600"
                onClick={(e) => e.stopPropagation()}
            >
                <h3 id="template-json-export-title" className="m-0 mb-1 text-lg font-semibold text-slate-800 dark:text-slate-200">
                    {labels?.title || 'JSON'}
                </h3>
                {fileName && (
                    <p className="m-0 mb-3 text-xs text-slate-500 dark:text-slate-400 font-medium">{fileName}</p>
                )}
                {labels?.hint && (
                    <p className="m-0 mb-2 text-xs text-slate-500 dark:text-slate-400 leading-relaxed">{labels.hint}</p>
                )}
                <textarea
                    readOnly
                    value={jsonText}
                    className="w-full flex-1 min-h-[min(50vh,320px)] p-3 border border-slate-200 dark:border-slate-600 rounded-lg text-xs font-mono text-slate-800 dark:text-slate-200 bg-slate-50 dark:bg-slate-900/80 resize-y mb-4"
                    spellCheck={false}
                />
                <div className="flex gap-2 justify-end flex-wrap">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-4 py-2 bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-200 border-none rounded-lg cursor-pointer font-semibold text-sm"
                    >
                        {labels?.close || 'Fechar'}
                    </button>
                    <button
                        type="button"
                        onClick={handleCopy}
                        className="px-4 py-2 bg-blue-600 text-white border-none rounded-lg cursor-pointer font-semibold text-sm hover:bg-blue-700"
                    >
                        {labels?.copy || 'Copiar'}
                    </button>
                </div>
            </div>
        </div>
    );
}
